<template>
  <div class="date-selector-inline">
    <div v-if="editMode">
      <el-button
        v-if="show_unset_button"
        size="mini"
        type="info"
        @click="onUnset"
        style="position: relative">Unset</el-button>
      <el-button
        v-if="show_never_button"
        size="mini"
        type="info"
        @click="onNeverOrToday"
        style="position: relative">{{button_text}}</el-button>
      <date-selector
        ref="date_selector"
        class="inline-date-select"
        v-bind:value="selectedDate"
        :type="type"
        :size="size"
        :placeholder="placeholder"
        :defaultIsToday="defaultIsToday"
        :disableBefore="disableBefore"
        @input="onInput"
        @blur="onSave"
        @change="onUpdate"
        :disabled="disabled" />
      <el-button
        v-if="show_confirm_button"
        size="mini"
        type="success"
        @click="onSave"
        style="position: relative">ok</el-button>
    </div>
    <template v-if="!editMode">
      <div @click.prevent="onStartEditMode">
        <template v-if="selectedDate">
          <template v-if="type === 'datetime'" >
            <div :class="[ disabled ? 'date-selector-inline-disabled' : 'date-selector-inline-enabled']">
              {{selectedDate|shortDateTime}}
            </div>
          </template>
          <template v-else>
            <div :class="[ disabled ? 'date-selector-inline-disabled' : 'date-selector-inline-enabled']">
              {{selectedDate|longDate}}
            </div>
          </template>
        </template>
        <template v-else>
          <div :class="[ disabled ? 'date-selector-inline-disabled' : 'date-selector-inline-enabled']">
            {{text_if_empty}}
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import DateSelector from './DateSelector'
import moment from '@/moment-gp'

export default {
  props: {
    value: {
      required: true
    },
    type: {
      default: "date"
    },
    show_never_button: {
      default: false
    },
    show_confirm_button: {
      default: false
    },
    show_unset_button: {
      default: false // Does not work at the moment
    },
    placeholder: {
      default: 'Pick a day'
    },
    text_if_empty: {
      type: String,
      default: 'never'
    },
    size: {
      default: 'medium'
    },
    disableBefore: {
      default: null // '2018-11-20'
    },
    defaultIsToday: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    button_text: '',
    selectedDate: null,
    editMode: false
  }),
  created() {
    /* DateSelector can handle it */
    this.selectedDate = this.value;

    if ( moment.isMoment( this.value) && !this.value.isValid() ) {
      this.selectedDate = null;
    }

    if ( this.defaultIsToday ) {
      this.button_text = 'today';
    } else {
      this.button_text = this.text_if_empty;
    }
  },
  methods: {
    onStartEditMode() {
      if (!this.disabled) {
        this.editMode = !this.editMode;
        this.$nextTick(() => {
          this.$refs.date_selector.focus();
        })
      }
    },

    onUpdate() {
      // console.log("this.selectedDate", this.selectedDate);
      this.$emit('input', this.selectedDate);
      if ( !this.show_confirm_button ) {
        this.onSave();
      }
    },

    onInput($event) {
      // console.log("onInput", $event);
      this.selectedDate = $event;
    },

    onNeverOrToday() {
      if ( !this.defaultIsToday ) {
        this.selectedDate = null;
      } else {
        this.selectedDate = moment.currentDate();
      }
      this.$emit('input', this.selectedDate);
      this.onSave();
    },

    onUnset() {
      this.selectedDate = undefined;
      // this.$emit('input', this.selectedDate);
      this.onSave();
    },

    onSave() {
      this.editMode = false;
      if ( moment.isMoment( this.selectedDate ) && this.selectedDate.isValid() ) {
        this.$emit('save', this.selectedDate)
      } else {
        this.$emit('save', null)
      }
    },

    onUnfocus() {
      /* We need to wait a little bit otherwise the button click on neveOrToday
        does not get triggered */
      setTimeout(() => {
        this.editMode = false;
      }, 100)
    }
  },
  components: {
    DateSelector
  }
}
</script>

<style>
.date-selector .inline-date-select {
  display: inline-block;
  margin: 0 0.1em;
  /* width: 11em; */
}
.date-selector-inline {
  display: inline-block;
  position: relative;
}
.date-selector-inline-disabled {
  color: #000000;
}
.date-selector-inline-disabled:hover {
  text-decoration: none !important;
  text-decoration-line: none !important;
}
.date-selector-inline-enabled {
  color: rgb(64, 158, 255);
}
.date-selector-inline-enabled:hover {
  text-decoration: underline
}
.date-selector-inline .el-date-editor.el-input {
  width: unset;
}
</style>
